import { Box, styled } from '@mui/material';

const AvatarContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'flex-start',
  gap: theme.spacing(1),
}));

export { AvatarContainer };
